import styled from 'styled-components';

const Card = styled.div`
  background: #fff;
  border-radius: 14px;
  padding: 1.5rem;
  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.08);
`;

const Item = styled.p`
  margin-bottom: 0.8rem;
`;

function ContactCard({ name, address, phone, email }) {
  return (
    <Card>
      <Item><strong>{name}</strong></Item>
      <Item>{address}</Item>
      <Item>
        Telefon: <a href={`tel:${phone.replace(/\s+/g, '')}`}>{phone}</a>
      </Item>
      <Item>
        E-Mail: <a href={`mailto:${email}`}>{email}</a>
      </Item>
    </Card>
  );
}

export default ContactCard;